import React from 'react'
import { Container } from './style'
// console.log( window.location.pathname)
export const Generic = () => {
    return (
        <Container>{window.location.pathname} Coming soon </Container>
    )
}
